import { Link } from 'react-router-dom';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

function trackForSale(source: string) {
  if (window.gtag) {
    window.gtag('event', 'for_sale_click', { source });
  }
}

export default function ForSaleArticleBlock() {
  return (
    <div className="my-10 rounded-2xl overflow-hidden border-2 border-[#DC2626]">
      <div className="bg-[#DC2626] px-5 py-2.5 flex items-center gap-2">
        <i className="ri-store-2-line text-white text-sm"></i>
        <span className="text-white font-bold text-sm tracking-wide uppercase">Acquisition Opportunity</span>
      </div>
      <div className="bg-red-50 px-5 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="text-gray-800 font-semibold text-base mb-1">
            This website is available for acquisition
          </p>
          <p className="text-gray-600 text-sm">
            A turnkey SEO and lead generation platform generating business funding inquiries. Fully managed with an admin dashboard — no technical skills required.
          </p>
        </div>
        <Link
          to="/for-sale"
          onClick={() => trackForSale('article_block')}
          className="flex-shrink-0 flex items-center gap-2 bg-[#DC2626] hover:bg-red-700 text-white text-sm font-bold px-5 py-2.5 rounded-lg cursor-pointer whitespace-nowrap transition-colors"
        >
          View Details
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </div>
  );
}
